import { api } from '../initFetch'

export const UploadAndReplaceItem = async (
  Name,
  ItemPath,
  DriveId,
  DocBlobRef,
  Token,
  TenantId
) => {
  const res = await api.post('/p4m/OneDrive/UploadAndReplaceItem', {
    Name,
    ItemPath,
    DriveId,
    DocBlobRef,
    Token,
    TenantId,
  })
  return res.json
}
